import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    uploadData:[],
    isUploading:false,
    status:null,
}

const token = userObj?.token

export const uploadFiles = createAsyncThunk(
    'order/uploadFiles',
    async (data, {rejectWithValue}) => {
        console.log(data)
        try{
            const response = await axios.post("Order/uploadfiles",data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

const uploadFilesSlice = createSlice({
    name: 'uploadFiles',
    initialState,
    reducers: {},
    extraReducers:{
        [uploadFiles.pending]: (state, action) => {
            state.status='pending';
            state.isUploading=true;
        },
        [uploadFiles.fulfilled]: (state, action) => {
            state.status='success';
            state.isUploading=false;
            state.uplaodData = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [uploadFiles.rejected]: (state, action) => {
            state.status='failed';
            state.isUploading=false;
        }
    }
})

export default uploadFilesSlice.reducer;